import { Component, AfterViewInit, ViewContainerRef, ViewChild, OnDestroy } from '@angular/core';
import { TaskHandler } from '../../tasks/TaskHandler';
import { ConfirmationService } from 'primeng-lts/api';
import { FormConfig } from '../../components/forms/form.objects';
import { WorkPublicationInfoDTO } from '../../api/plyca-dtos';
import { PublicationInfoDTO, ValidationResultDTO, ResultTypeDTO } from '../../api/plyca-dtos-v2';
import { Configuration } from '../../conf/app.constants';
import { FormService } from '../../components/forms/form.service';
import { formPlycaComponent } from '../../components/forms/formPlyca.component';
import { tap, finalize, catchError } from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { of } from 'rxjs';


@Component({
  selector: 'publicationInfo',
  templateUrl: 'publicationInfo.template.html'
})
export class publicationInfoComponent extends TaskHandler implements AfterViewInit, OnDestroy {
  infoLoaded = false;
  formConfig: FormConfig;
  @ViewChild('frmPUB') frmPub: formPlycaComponent;
  formPartyTenderRecipientConfig: FormConfig;
  formAdditionalInformationPartyConfig: FormConfig;
  publicationInfo: WorkPublicationInfoDTO;

  constructor(private configuration: Configuration,
    private headerActionsService: HeaderActionsService) {
    super();
  }


  ngAfterViewInit(): void {
    this.publicationInfo = this.task.work;

    // invocamos al metodo que crea los subobjetos
    PublicationInfoDTO.patchDTO(this.publicationInfo.publicationInfo);

    // cargamos el form
    let jsonForm = 'publicationInfoInterfaceSettings.json';
    this.formConfig = new FormConfig(undefined, jsonForm, this.publicationInfo);
    this.formConfig.showValidations = true;
    // this.formPartyTenderRecipientConfig = new FormConfig(
    //   'addressInterfaceSettings.json',
    //   this.publicationInfo.tenderRecipientParty
    // );
    // this.formAdditionalInformationPartyConfig = new FormConfig(
    //   'addressInterfaceSettings.json',
    //   this.publicationInfo.additionalInformationParty
    // );
    this.infoLoaded = true;
    this.waitService.cancelWaiting();

    this.subscribe(this.headerActionsService.addAction(
      'General.accept',
      'fa fa-lg fa-check',
      'btn-primary',
      true
    ), success => {
      this.processTask();
    });
    this.subscribe(this.headerActionsService.addAction(
      'General.back',
      'fas fa-lg fa-times',
      'btn-outline-secondary',
      true
    ), success => {
      this.salir();
    });
  }

  isInfoLoaded(): boolean {
    return this.infoLoaded;
  }

  ngOnDestroy() {
    this.headerActionsService.clearActions();
    super.ngOnDestroy();
  }

  processTask() {
    console.log('processTask de PUBLICATIONINFO:');
    this.waitService.startWaiting();
    this.subscribe(this.frmPub.getValidateObservable('tasks/' + this.task.identifier + '/infopublications/validations/update', this.publicationInfo)
      .pipe(
        tap((res: HttpResponse<ValidationResultDTO>) => {
          if (res.body.result === ResultTypeDTO.OK) {
            super.processTask();
          } else {
            this.waitService.cancelWaiting();
            this.confirmationService.confirm({
              message: 'Se han detectado errores que impiden tramitar. ¿Desea grabar la ficha?',
              accept: () => {
                super.processTask();
              },
              reject: () => {
                this.waitService.cancelWaiting();
                console.log('NO HACE NADA FPUB');
              }
            });
          }
        }),
        catchError((err: any) => {
          // por si acaso limpiamos sesion
          this.waitService.cancelWaiting();
          return of(undefined);
        })
      ));
  }

}
